import React from 'react';

const ChatMessage = ({ message }) => {
  const formatMessage = (text) => {
    return text.split('\n').map((line, index) => {
      if (line.startsWith('###')) {
        return <h3 key={index}>{line.replace('###', '').trim()}</h3>;
      } else if (line.startsWith('**') && line.endsWith('**')) {
        return <strong key={index}>{line.replace(/^\*\*|\*\*$/g, '')}</strong>;
      } else if (line.startsWith('- ')) {
        return <li key={index}>{formatLine(line.substring(2))}</li>;
      } else if (line.trim() === '') {
        return <br key={index} />;
      } else {
        return <p key={index}>{formatLine(line)}</p>;
      }
    });
  };

  const formatLine = (line) => {
    const parts = line.split(/(\*\*.*?\*\*|\[.*?\]\(.*?\))/);
    return parts.map((part, index) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        return <strong key={index}>{part.slice(2, -2)}</strong>;
      } else if (part.startsWith('[') && part.includes('](')) {
        const [text, url] = part.slice(1, -1).split('](');
        return <a key={index} href={url}>{text}</a>;
      } else {
        return part;
      }
    });
  };

  return (
    <div className={message.user === 'You' ? 'user-message' : 'assistant-message'}>
      <strong>{message.user}:</strong>
      <div>{formatMessage(message.text)}</div>
    </div>
  );
};

export default ChatMessage;